
import { common } from './common/es';
import { products } from './products/es';
import { pricing } from './pricing/es';
import { solutions } from './solutions/es';

export const es = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
